<template>
  <JModal v-model="internalModelValue" noBody>
    <template #navigation>
      <button @click="helpStore.toggleHelpModal(true)">
        <JIcon
          name="question-mark-outline"
          class="text-metadata text-gray-500"
        />
      </button>
    </template>

    <ReviewTrips />
  </JModal>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { JIcon, JModal } from '@journey/ui-kit'
import ReviewTrips from '../ReviewTrips/ReviewTrips.vue'
import type { Emits, Props } from './ReviewTripsModal.types'
import useHelpStore from '@/modules/Help/store'

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
})

const emit = defineEmits<Emits>()

// TOGGLE
const internalModelValue = useVModel(props, 'modelValue', emit)

const helpStore = useHelpStore()
</script>
